<template>
  <div class="loader">
    <span class="loader__bg" />

    <ul class="loader__cloud-container">
      <li class="loader__cloud" v-for="n in 4" :key="n">
        <img :src="`/img/misc/cloud-0${(n + 1) % 2}.png`" alt="Loader clud image background">
      </li>
    </ul>

    <p class="loader__text">
      {{ $translate('loader') }}
      <span class="text__dot">.</span>
      <span class="text__dot">.</span>
      <span class="text__dot">.</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'Loader',
};
</script>

<style lang="scss" scoped>
@keyframes dot-flap {
  0% {
    transform: translateY(0) scaleY(1);
    transform-origin: 50% 0%;
  }
  30% {
    transform: translateY(-5px) scaleY(1.2);
    transform-origin: 50% 100%;
  }
  70% {
    transform: translateY(0) scaleY(1);
  }
  100% {
    transform: translateY(0) scaleY(1);
  }
}

@keyframes cloud0 {
  0% {
    transform: translateX(-15vw);
  }
  100% {
    transform: translateX(12vw);
  }
}
@keyframes cloud1 {
  0% {
    transform: translateX(5vw);
  }
  100% {
    transform: translateX(-7vw);
  }
}
@keyframes cloud2 {
  0% {
    transform: translateX(-9vw);
  }
  100% {
    transform: translateX(9vw);
  }
}
@keyframes cloud3 {
  0% {
    transform: translateX(12vw);
  }
  100% {
    transform: translateX(-15vw);
  }
}

.loader {
  position: fixed;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;
  z-index: 10;

  &,
  &__bg {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  &__bg,
  &__cloud-container {
    position: absolute
  }

  &__bg {
    @include sky-gradient();
  }

  &__cloud-container {
    width: 100vw;
    height: 100%;
    top: 0;
    left: 0;

    @include mq($until: ipadP) {
      left: -150vw;
      width: 300vw;
    }
  }

  &__cloud {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    img {
      display: block;
      width: 100%;
    }

    &.loader__cloud--mirrored img {
      transform: scaleX(-1);
    }

    &:nth-child(1) {
      top: -20%;
      left: -15%;

      transform: translateX(-15vw);
      animation: cloud0 62s linear 0s infinite alternate;
    }
    &:nth-child(2) {
      top: 15%;
      left: 5%;

      transform: translateX(5vw);
      animation: cloud1 67s linear 0.15s infinite alternate;
    }
    &:nth-child(3) {
      top: 35%;
      left: 10%;

      transform: translateX(-9vw);
      animation: cloud2 63s linear 0.2s infinite alternate;
    }
    &:nth-child(4) {
      left: -7%;
      top: -25%;

      transform: translateX(12vw);
      animation: cloud3 60s linear 0.22s infinite alternate;
    }
  }

  &__text {
    position: relative;

    color: $color-green;
    @extend %font-medium;
  }

  .text__dot {
    display: inline-block;

    &:nth-child(1) {
      animation: dot-flap 1.75s $flap 0s infinite normal;
    }
    &:nth-child(2) {
      animation: dot-flap 1.75s $flap 0.25s infinite normal;
    }
    &:nth-child(3) {
      animation: dot-flap 1.75s $flap 0.5s infinite normal;
    }
  }
}
</style>
